import { MinterConfig } from '../../features/data/apis/config-types';

export const minters: MinterConfig[] = [];
